export const NoCodeDecisionGuide = () => (
  <section className="py-8 sm:py-12">
    <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">When to Use What</h2>
    <div className="grid md:grid-cols-2 gap-6">
      <div className="bg-primary/5 rounded-xl border border-primary/20 p-6">
        <h3 className="font-semibold text-foreground mb-4">✓ Use No-Code When:</h3>
        <ul className="space-y-2 text-muted-foreground">
          <li>• Validating a new idea quickly</li>
          <li>• Building internal tools</li>
          <li>• Budget is limited</li>
          <li>• Standard workflows (forms, CRM, etc.)</li>
          <li>• Non-technical founder</li>
        </ul>
      </div>
      <div className="bg-chart-2/5 rounded-xl border border-chart-2/20 p-6">
        <h3 className="font-semibold text-foreground mb-4">✓ Use Custom Code When:</h3>
        <ul className="space-y-2 text-muted-foreground">
          <li>• Unique/complex features needed</li>
          <li>• Scaling to thousands of users</li>
          <li>• Full control over UX required</li>
          <li>• Integrating custom algorithms</li>
          <li>• Long-term product vision</li>
        </ul>
      </div>
    </div>
  </section>
);
